import React, {Component} from 'react'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import adicionarFiltroCupom from '../../actions/cupom/adicionarFiltroCupom';
import removerFiltroCupom from '../../actions/cupom/removerFiltroCupom';
import listarFiltrosCupom from '../../actions/cupom/listarFiltrosCupom';
import {
    FILTRO_DATA_CRIACAO,
    FILTRO_EMAIL_USUARIO,
    FILTRO_IDENTIFICACAO,
    FILTRO_PLATAFORMA,
    FILTRO_TIPO,
    FILTRO_VALIDO
} from '../../util/filtros';
import FiltroChaveValor from '../comum/FiltroChaveValor';
import FiltroBuscaCupom from './FiltroBuscaCupom';

export class FiltroCupom extends Component {
    componentDidMount() {
        this.props.listarFiltrosCupom()
    }


    adicionarFiltro(filtro) {
        this.props.adicionarFiltroCupom(filtro)
    }

    removerFiltro(filtro) {
        this.props.removerFiltroCupom(filtro)
    }

    render() {
        if (!this.props.plataformas) {
            return <div>Carregando...</div>
        }

        return (
            <React.Fragment>
                <div className="conteudo">
                    <FiltroBuscaCupom
                        filtro={FILTRO_DATA_CRIACAO}
                        opcoes={[new Date().getFullYear()]}
                        isFiltroData={true}
                    />
                    <FiltroChaveValor
                        filtro={FILTRO_PLATAFORMA}
                        opcoes={this.props.plataformas}
                        filtrosAdicionados={this.props.filtrosAdicionados}
                        adicionarFiltro={this.adicionarFiltro.bind(this)}
                        removerFiltro={this.removerFiltro.bind(this)}
                    />
                    <FiltroChaveValor
                        filtro={FILTRO_TIPO}
                        opcoes={this.props.tipos}
                        filtrosAdicionados={this.props.filtrosAdicionados}
                        adicionarFiltro={this.adicionarFiltro.bind(this)}
                        removerFiltro={this.removerFiltro.bind(this)}
                    />
                    <FiltroBuscaCupom
                        filtro={FILTRO_IDENTIFICACAO}
                        isNome={true}
                    />
                    <FiltroBuscaCupom
                        filtro={FILTRO_EMAIL_USUARIO}
                        isNome={true}
                        opcoes={[]}
                    />
                    <FiltroBuscaCupom
                        filtro={FILTRO_VALIDO}
                        opcoes={['Válido', 'Inválido']}
                        isRadio={true}
                    />
                </div>
            </React.Fragment>
        )
    }
}

export const mapStateToProps = state => ({
    plataformas: state.filtrosCupom.plataformas,
    tipos: state.filtrosCupom.tipos,
    filtrosAdicionados: state.filtrosAdicionadosCupom

});

export const mapDispatchToProps = dispatch => (
    bindActionCreators({
        adicionarFiltroCupom,
        removerFiltroCupom,
        listarFiltrosCupom
    }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(FiltroCupom)
